// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_FACET_CATS = "Kategorie";
